import useDBO from '../../hooks/useDBO';
import Loading from "../../Loading";
import Error from "../../components/Error";
import { useParams } from 'react-router-dom';
import SLink from '../../components/SLink';
import StoppedReasons from '../../components/StoppedReasons';
import StoppedReason from '../student/components/StoppedReason';

  
  export default function RecentStopped() {
  const {classid} = useParams()
    const data = useDBO(`/recent-stopped/${classid}`)
  

  if (data.loading) return <Loading />
  if(data.error) return <Error />
  
  console.log(data)

    return (
      <div>
        {data.map((student) => (
          <div style={{ display: "flex" }}>
            <div style={{ width: 300, minWidth: 300 }}>
              <SLink
                id={student._id}
                showPhone
                status
              />
            </div>
            <div style={{ width: 100, minWidth: 100 }}>
              {new Date(student.statusChanged).fDate()}
            </div>
            <div style={{ width: 200, minWidth: 200 }}>
              <StoppedReasons stoppedReasons={student.stoppedReasons} />
            </div>
            <div style={{ fontSize: 12 }}>
              <StoppedReason history={student.statusHistory} vn/>
            </div>
          </div>
        ))}
      </div>
    );
  };